import React, { useState } from "react";
import { GlobalStyle, Title, Center, Tabs, Tab } from "./styles";
import Table from "./components/Table";
import LineChart from "./components/Graph";

const Component = ({ filters, initialActiveTab = "table", showTabs = true }) => {
  const [activeTab, setActiveTab] = useState(initialActiveTab);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  return (
    <>
      <GlobalStyle />
      <div
        style={{
          height: 38 * itemsPerPage + 176,
          width: "100%",
          backgroundColor: "#f7f3f3",
          padding: "15px",
          borderRadius: "20px",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Title>
          <span>PMC y Cond. de pago {filters && filters.cliente && !showTabs ? `: ${filters.cliente}` : ""}</span>

          {showTabs && (
            <Tabs>
              <Tab
                type="button"
                onClick={() => {
                  setActiveTab("table");
                }}
                isActive={activeTab === "table"}
              >
                Tabla
              </Tab>
              <Tab
                type="button"
                onClick={() => {
                  setActiveTab("graph");
                }}
                isActive={activeTab === "graph"}
              >
                Gráfico
              </Tab>
            </Tabs>
          )}
        </Title>

        <div style={{ height: 10 }} />

        {!filters.cliente ? (
          <Center>
            <b>Selecciona un cliente</b>
            <p>Para visualizar el PMC y condición de pago de un cliente, debes seleccionar una razón social.</p>
          </Center>
        ) : (
          <>{activeTab === "table" ? <Table filters={filters} setItemsPerPage={setItemsPerPage} /> : <LineChart filters={filters} />}</>
        )}
      </div>
    </>
  );
};

export default Component;
